import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";

import { DEMITIDO } from "../DocumentosFuncionarioTable";
import { formatDate } from "../../../helpers/formatDate";

const DemitidoOverlay = ({ funcionario }) => {
  return funcionario.statusContratoFuncionario === DEMITIDO ? (
    <OverlayTrigger
      placement="top"
      overlay={
        <Popover
          hidden={!funcionario.dataDemissao?.date}
          className="p-1"
          id="afastamento-tooltip"
        >
          {funcionario.dataDemissao?.date &&
            formatDate(funcionario.dataDemissao.date)}
        </Popover>
      }
    >
      <small
        className="badge-pill badge-danger py-1 px-2 mx-1 font-weight-bold text-uppercase"
        style={{ background: "#f15923" }}
      >
        Demitido
      </small>
    </OverlayTrigger>
  ) : null;
}

export default DemitidoOverlay;
